

import apiClient from '@/axios';

export async function getPermissions() {
    return apiClient.get("/admin/permissions");
  }


  export const createRoleWithPermissions = async (roleData) => {
    try {
      const response = await apiClient.post('/admin/create-permission', roleData);
      return response.data;
    } catch (error) {
      console.error("Ошибка при создании или обновлении роли:", error);
      throw error;
    }
  };